import { HttpClient } from '@angular/common/http';
import { Injectable, makeStateKey, StateKey, inject } from '@angular/core';

import { Observable, of, catchError } from 'rxjs';

import { ConfigService } from '@fcom/core/services/config/config.service';
import { MonitoringLogger } from '@fcom/core/services/monitoring/monitoring-logger';
import { StateTransferService } from '@fcom/core/services/state-transfer/state-transfer.service';

import { AmDestinationResponseItem } from '../interfaces/destination-search.interface';

@Injectable()
export class AmDestinationService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);
  private monitoringLogger = inject(MonitoringLogger);
  private stateTransferService = inject(StateTransferService);

  static createStateKey = (): StateKey<AmDestinationResponseItem[]> =>
    makeStateKey<AmDestinationResponseItem[]>('amdestinations');

  public amDestinationList(): Observable<AmDestinationResponseItem[]> {
    if (this.configService.cfg.buildEnv === 'prod') {
      return this.stateTransferService.wrapToStateCache(AmDestinationService.createStateKey(), () =>
        this.fetchAmDestinationList()
      );
    }
    return this.fetchAmDestinationList();
  }

  private fetchAmDestinationList(): Observable<AmDestinationResponseItem[]> {
    const apiUrl = this.configService.cfg.amFlightHotelDestinationUrl;
    const apiUrlLocalized = `${apiUrl}?dep=HEL`;
    return this.http.get<AmDestinationResponseItem[]>(apiUrlLocalized).pipe(
      catchError((err: unknown) => {
        if (['prod', 'staging'].includes(this.configService.cfg.buildEnv)) {
          this.monitoringLogger.warn('Failed to fetch AM flight + hotel list', { error: err });
        }
        return of([]);
      })
    );
  }
}
